/**
 * The longest prompt a person sends a session, from the web composer or over
 * MCP. It has a module of its own, so a route's test can mock the session
 * service without restating it.
 */
export const CODE_PROMPT_MAX_LENGTH = 100_000;
